var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExploreDj(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Explore",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "solid/headphones-alt",
    style: {
      mixBlendMode: "overlay"
    },
    fill: "#FCFCFC"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176,282.666667 L162.666666,282.666667 C133.208333,282.666667 109.333333,306.583333 109.333333,336.1 L109.333333,389.233334 C109.333333,418.741667 133.208333,442.666667 162.666666,442.666667 L176,442.666667 C190.725,442.666667 202.666667,430.7 202.666667,415.95 L202.666667,309.383333 C202.666667,294.625 190.725,282.666667 176,282.666667 Z M349.333333,282.666667 L336,282.666667 C321.275,282.666667 309.333333,294.625 309.333333,309.383333 L309.333333,415.95 C309.333333,430.7 321.275,442.666667 336,442.666667 L349.333333,442.666667 C378.791667,442.666667 402.666667,418.741667 402.666667,389.233334 L402.666667,336.1 C402.666667,306.591667 378.791667,282.666667 349.333333,282.666667 Z M256,69.3333329 C136.758333,69.3333329 46.4749995,168.608333 42.6666661,282.666667 L42.6666661,376 C42.6666661,383.366667 48.6333328,389.333333 55.9999995,389.333333 L69.3333329,389.333333 C76.6999996,389.333333 82.6666661,383.366667 82.6666661,376 L82.6666661,282.666667 C82.6666661,187.108333 160.441666,109.5 256,109.483333 C351.558334,109.5 429.333334,187.108333 429.333334,282.666667 L429.333334,376 C429.333334,383.366667 435.3,389.333333 442.666666,389.333333 L456,389.333333 C463.366667,389.333333 469.333334,383.366667 469.333334,376 L469.333334,282.666667 C465.525001,168.608333 375.241667,69.3333329 256,69.3333329 Z",
    id: "headphones-alt"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExploreDj);
export default __webpack_public_path__ + "static/media/iconExploreDJ.96422827.svg";
export { ForwardRef as ReactComponent };